@if (page$ | async; as page) {
  <div>
    @if (filter$ | async; as filter) {
      <div fxLayout="column" fxLayoutGap="1rem">
        <div class="filter-toolbar">
          <tnb-netzzuordnungen-filter
            (filter)="filterChanged($event)"
            [initialFilter]="filter"
          ></tnb-netzzuordnungen-filter>
        </div>
        <div fxLayout="column" fxLayoutGap="1rem">
          <div style="display: flex; justify-content: flex-end;">
            <div class="confirm-up-to-date">
              <button (click)="updateLastUuidChangeConfirmDate()"
                      [disabled]="isNumberOfUncofirmedUuidsSmallerorEqual0()"
                      matButton="filled"
              >
                  <mat-icon svgIcon="innogy_picto_check"></mat-icon>
                  Geänderte UUID's bestätigen
              </button>
              <mat-icon [matTooltip]="unconfirmedUuidTooltipText"
                        matTooltipClass="multiline-tooltip"
                        matTooltipPosition="right"
                        svgIcon="innogy_picto_speech-bubble_exclamationmark"
                        aria-hidden="false"
                        [attr.aria-label]="unconfirmedUuidTooltipText"
              >
              </mat-icon>
            </div>
          </div>
          @if (netzzuordnungenPage$ | async; as netzzuordnungPage) {
            <div
              data-qa="netzzuordnungen-result">
              <tnb-netzzuordnungen-table (sortChange)="sortChange($event)"
                [netzbetreiberType]="profile.netzbetreiberType"
                [netzzuordnungen]="netzzuordnungPage.content"
                [sortActive]="page.sort"
                [sortDirection]="page.direction"
                >
              </tnb-netzzuordnungen-table>
              <mat-paginator #paginator
                (page)="pageChange($event)"
                [hidePageSize]="true"
                [length]="netzzuordnungPage.totalElements"
                [pageIndex]="page.page"
                [pageSize]="PAGE_SIZE"
                [showFirstLastButtons]="false"
                >
              </mat-paginator>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
